import { render, staticRenderFns } from "./JobsLayout.vue?vue&type=template&id=37fdeb1c&scoped=true"
import script from "./JobsLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobsLayout.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./JobsLayout.vue?vue&type=style&index=0&id=37fdeb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fdeb1c",
  null
  
)

export default component.exports